/**
 * Feuille : un choix court, une aide ou un petit réglage, qui monte du bas au
 * téléphone (au pouce) et s'ouvre au centre sur ordinateur. Un sur-titre dit ce
 * qu'elle fait, un titre dit sur quoi, puis le contenu et son pied (l'action de
 * la feuille, puis « Annuler »). Une saisie complète reste une page dédiée
 * (`CreatePage`) : la feuille ne sert qu'aux gestes de quelques secondes.
 */
import type { ReactNode } from 'react';
import { Overlay } from '../overlay.js';

interface SheetContent {
  title: string;
  /** Ce que fait la feuille (« Ajouter au planning »), en petites capitales. */
  kicker?: string | undefined;
  description?: ReactNode;
  children: ReactNode;
  /** Pied : l'action de la feuille, puis « Annuler ». */
  footer?: ReactNode;
}

/** Le contenu de la feuille, sans le voile : sert aussi à la galerie et aux tests. */
export function SheetPanel(props: SheetContent): ReactNode {
  return (
    <div className="ui-sheet" data-ui="sheet">
      <div className="ui-sheet__head">
        {props.kicker ? <span className="ui-sheet__kicker">{props.kicker}</span> : null}
        <h2 className="ui-sheet__title">{props.title}</h2>
        {props.description ? <p className="ui-sheet__description">{props.description}</p> : null}
      </div>
      <div className="ui-sheet__body">{props.children}</div>
      {props.footer ? <div className="ui-sheet__footer">{props.footer}</div> : null}
    </div>
  );
}

export function Sheet(props: SheetContent & {
  onClose: () => void;
  /** Glisser vers le bas ferme la feuille : jamais quand elle porte une saisie. */
  swipeDismiss?: boolean;
}): ReactNode {
  const { onClose, swipeDismiss, ...content } = props;
  return (
    <Overlay label={props.title} onClose={onClose} variant="feuille" swipeDismiss={swipeDismiss ?? false}>
      <div className="sheet-handle" aria-hidden="true" />
      <SheetPanel {...content} />
    </Overlay>
  );
}
